import {RestrictedRouteModuleConfiguration} from "./model/UserPermission";
import {AngularJsMaterialModuleName, NgRouteModuleName, RouterModuleName} from "../utils/names/requiredModulesNames";


export const RouterModulesConfigurations = new RestrictedRouteModuleConfiguration(
    RouterModuleName,
    [
        AngularJsMaterialModuleName,
        NgRouteModuleName
    ],
    [],
    [],
    [],
    []
);
